export enum SupportedFormats {
    wav = "audio/wav"
};

export interface IFormatProperties {
    format: SupportedFormats,
    bitsPerSample: number,
    sampleRateHz: number,
    countOfChannels: number,
    compressionPreferredKbps?: number
};

export interface IAudioFile {
    file: File,
    duration: number
};

export interface IAudioFormat {
    InitializeEncoder(props: IFormatProperties): void
    EncodeChunk(chunk: Float32Array): ArrayBuffer;
    EncodeFileUsingChunks(fileName: string, chunks: ArrayBuffer[]): Promise<IAudioFile>;
};